
import { Toaster } from "components";

import { homeConstants } from '../constants';

import { func_validation, func_serviceHandling, isNumberValid, isStringTrimNotEmpty, isObjectNotEmpty } from 'functions';

import { promiseInstance_authorization } from './config';
import moment from "moment";



export const homeActions = {
	getOneClickActionDetails,
	getInvoiceDetailList,

	generateAllUnbilledInvoices,
	generateAllUnbilledAdvancePayInvoices,
	postAllUnpostedInvoicesToSqlAccount,
	sendAllPendingInvoices,
	generateCompareUnpostedInvoices,
}

function getOneClickActionDetails(paramObj) {
    return dispatch => {
        dispatch(request());

		let url = func_serviceHandling.createUrlWithParams('/Dashboard', paramObj)

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.getOneClickActionDetails_request, details }; }
    function success(details) { return { type: homeConstants.getOneClickActionDetails_success, details }; }
    function failure(error) { return { type: homeConstants.getOneClickActionDetails_failure, error }; }
}

function getInvoiceDetailList(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			...filterOptions,
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/Search', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.getInvoiceDetailList_request, details }; }
    function success(details) { return { type: homeConstants.getInvoiceDetailList_success, details }; }
    function failure(error) { return { type: homeConstants.getInvoiceDetailList_failure, error }; }
}

function generateAllUnbilledInvoices(endDate) {
    return dispatch => {
		dispatch(request());
		
		let endDate_validated = "";
		if (isStringTrimNotEmpty(endDate)) endDate_validated = encodeURI(endDate);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/GenerateAllUnbilledInvoice?dateBillDate=' + endDate_validated)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully generated all unbilled invoices"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate all unbilled invoices";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.generateAllUnbilledInvoices_request, details }; }
    function success(details) { return { type: homeConstants.generateAllUnbilledInvoices_success, details }; }
    function failure(error) { return { type: homeConstants.generateAllUnbilledInvoices_failure, error }; }
}

function generateAllUnbilledAdvancePayInvoices(endDate) {
    return dispatch => {
		dispatch(request());
		
		let endDate_validated = "";
		if (isStringTrimNotEmpty(endDate)) endDate_validated = encodeURI(endDate);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/generateAllUnbilledAdvancePayInvoices?dateBillDate=' + endDate_validated)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully generated all unbilled advance pay invoices"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
					
					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate all unbilled advance pay invoices";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.generateAllUnbilledAdvancePayInvoices_request, details }; }
    function success(details) { return { type: homeConstants.generateAllUnbilledAdvancePayInvoices_success, details }; }
    function failure(error) { return { type: homeConstants.generateAllUnbilledAdvancePayInvoices_failure, error }; }
}

function postAllUnpostedInvoicesToSqlAccount() {
    return dispatch => {
        dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/PostAllUnpostedToNetsuite')
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully posted all unposted invoices"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to post all unposted invoices";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.postAllUnpostedInvoicesToSqlAccount_request, details }; }
    function success(details) { return { type: homeConstants.postAllUnpostedInvoicesToSqlAccount_success, details }; }
    function failure(error) { return { type: homeConstants.postAllUnpostedInvoicesToSqlAccount_failure, error }; }
}

function sendAllPendingInvoices(isSentToCustomers) {
    return dispatch => {
		dispatch(request());
		
		let queryString = "";
		if (isSentToCustomers) queryString = "?sendToCustomer=true";

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/AllPendingInvoices/SendEmail' + queryString)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully sent pending invoices"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to send pending invoices";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.sendAllPendingInvoices_request, details }; }
    function success(details) { return { type: homeConstants.sendAllPendingInvoices_success, details }; }
    function failure(error) { return { type: homeConstants.sendAllPendingInvoices_failure, error }; }
}

function generateCompareUnpostedInvoices() {
    return dispatch => {
        dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/Invoice/CompareUnpostedInvoice')
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully get compare unposted invoices"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get compare unposted invoices";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: homeConstants.generateCompareUnpostedInvoices_request, details }; }
    function success(details) { return { type: homeConstants.generateCompareUnpostedInvoices_success, details }; }
    function failure(error) { return { type: homeConstants.generateCompareUnpostedInvoices_failure, error }; }
}